import { useState, useEffect } from "react";
export default function useImage(url) {
  const [img, setImg] = useState(null);
  useEffect(() => {
    if (!url) return;
    const image = new window.Image();
    image.crossOrigin = "anonymous";
    image.src = url;
    image.onload = () => setImg(image);
    return () => setImg(null);
  }, [url]);
  return [img];
}
